/**
 * The scheduler's query keys, kept apart from its hooks so the reports hooks
 * can invalidate them without the two modules importing each other.
 */
export const SCHEDULER_LIST_KEY = "reports/scheduler";
export const SCHEDULER_ITEM_KEY = "reports/scheduler/id";
export const SCHEDULER_FILTER_KEY = "reports/scheduler/filter";

/** Every scheduler key, for the callers that date all of them at once. */
export const SCHEDULER_KEYS = [
  SCHEDULER_LIST_KEY,
  SCHEDULER_ITEM_KEY,
  SCHEDULER_FILTER_KEY
];
